<template>
    <i :class="`yy-icon-153-${type}`" :style="{'font-size': size}">
    </i>
</template>
<script>
/**
 * YYIcon
 * @displayName YYIcon
 */
export default {
    name: 'YYIcon',
    props: {
        /**
         * 图标类型
         */
        type: {
            type: String
        },
        /**
         * 图标大小
         * @values 14px...
         */
        size: {
            type: String
        }
    }
}
</script>
